'use client';

import { useLiveQuery } from '@sanity/preview-kit';
import { FC } from 'react';
import Documentation from '@/src/components/screens/documentation/Documentation';
import themeQuery from '@/src/lib/queries/themeQuery';
import { ITheme } from '@/src/lib/types/themeInterface';

interface PreviewDocPageProps {
  data: ITheme;
  slug: string;
}

const PreviewDocPage: FC<PreviewDocPageProps> = ({ data, slug }) => {
  const [themeData] = useLiveQuery(data, themeQuery(slug));

  return <Documentation docData={themeData} />;
};

export { PreviewDocPage };
